import React from 'react';
import { Check, X, ArrowRight, Layers, Clock, BookOpen, TrendingUp, Shield, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
import { EdgePricing } from '../components/EdgePricing';
export function EdgeProduct() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-858" data-mp="1r2kvejqrjni6">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-859" data-mp="yfrspvttce5j">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-slate-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-860" data-mp="uf7vytd5jcjx" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-861" data-mp="187np92g93w7n">
          <div className="inline-block px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-slate-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-862" data-mp="aqyqxiqifc30">
            Recruiting Infrastructure
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-863" data-mp="2lum4p27qgkqd">
            HIRE Edge
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-864" data-mp="2qmma3a6ko5uc">
            Predictable applicant flow — without changing how you run your team.
          </p>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto border-t border-slate-800 pt-8" data-id="element-865" data-mp="1xyqds6kx0fy3">
            HIRE Edge is designed for teams that want better candidates while
            keeping hiring and onboarding internal.
          </p>
        </motion.div>
      </section>

      <EdgePricing data-id="element-866" data-mp="2bxgc1pjh0lo1" />

      {/* 2. WHAT EDGE IS (AND ISN'T) */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-867" data-mp="3jarvlz5g9yv8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-868" data-mp="3jd483wsfvh0w">
          <div data-id="element-869" data-mp="3nasafkwgoc2t">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-870" data-mp="3neg4qm9qd2il">
              <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-871" data-mp="1o61z397e2536" />
              HIRE Edge is:
            </h3>
            <ul className="space-y-4" data-id="element-872" data-mp="1j88toidwtf3y">
              {['A recruiting infrastructure layer', 'A predictable source of pre-screened applicants', 'A clean, managed top-of-funnel system'].map((item, idx) => <li key={idx} className="text-slate-300 flex items-start" data-id="element-873" data-mp="14knq6nd4hdvi" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-874" data-mp="10ikcds2zdx72" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-875" data-mp="19ip998ajtd6z">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-876" data-mp="19i74todqfsnz">
              <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-877" data-mp="lt4nyiqxa3uj" />
              HIRE Edge is not:
            </h3>
            <ul className="space-y-4" data-id="element-878" data-mp="gub9oo3ta8tb">
              {['A hiring or onboarding solution', 'A training or retention program', 'A replacement for internal leadership'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-879" data-mp="2x9ohveth81mv" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-880" data-mp="2jhroz8jzhnpf" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 3. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-881" data-mp="3c39pg134zxd2">
        <div className="max-w-6xl mx-auto" data-id="element-882" data-mp="3g66cq53mghnc">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-883" data-mp="327pw9mfyjcs0">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-884" data-mp="37588pmt6oa4r">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-slate-700 rounded-xl p-8 relative overflow-hidden" data-id="element-885" data-mp="1qr00yyd2o5d6">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-886" data-mp="1vspb8bsh0f07" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-887" data-mp="2b1t0vdyatvnh">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-888" data-mp="269j1l7banj8j" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-889" data-mp="229injns3xa20">
                {['Job boards and recruiting traffic', 'Screening and pre-qualification', 'Multi-market coordination', 'Reporting and visibility'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-890" data-mp="2pz36w7s6a9bt" data-mpi={idx}>
                    <Check className="w-5 h-5 text-slate-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-891" data-mp="2kyfhfqjle0jp" />
                    <span data-id="element-892" data-mp="2g0477epdxo0y">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-700 rounded-xl p-8 relative overflow-hidden" data-id="element-893" data-mp="19ld4d5gpbt4a">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3]" data-id="element-894" data-mp="14je07td50s6a" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-895" data-mp="ui38abwjw6wm">
                <span className="w-2 h-2 rounded-full bg-[#7FE0C3] mr-3" data-id="element-896" data-mp="zgwpaeb1qg1j" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-897" data-mp="14e6dxrqm2nob">
                {['Interviews and hiring decisions', 'Onboarding and training', 'Retention and performance'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-898" data-mp="1i6cq72qn8aih" data-mpi={idx}>
                    <Check className="w-5 h-5 text-[#7FE0C3] mr-3 mt-0.5 flex-shrink-0" data-id="element-899" data-mp="1i8fp6c9rxdzc" />
                    <span data-id="element-900" data-mp="1n67fj1urss1f">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-8 text-center" data-id="element-901" data-mp="3owsr6mqm5ead">
            <p className="text-slate-400" data-id="element-902" data-mp="3oy42r8qavqc1">
              Edge works best when your internal team already knows how to hire
              and onboard effectively.
            </p>
          </div>
        </div>
      </section>

      {/* 4. HOW EDGE FITS INTO THE SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-903" data-mp="3gwmndpgar2qe">
        <div className="bg-slate-900/30 border border-slate-800 rounded-xl p-8 md:p-12 text-center" data-id="element-904" data-mp="3gyhanaf1j6xn">
          <h2 className="text-2xl font-bold text-white mb-6" data-id="element-905" data-mp="3vr11bbl07ly7">
            How Edge Fits Into The System
          </h2>
          <p className="text-slate-300 mb-6 leading-relaxed" data-id="element-906" data-mp="8oef8j6ygj25">
            All HIRE partners use the same 10-step recruiting system. Edge
            focuses on the infrastructure stages so your team can handle
            execution.
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-sm" data-id="element-907" data-mp="idxxbmmug8vy">
            {['Attract', 'Engage', 'Screen', 'Qualify'].map((step, idx) => <span key={idx} className="px-4 py-2 bg-slate-800 border border-slate-700 rounded-full text-slate-400" data-id="element-908" data-mp="rew0y3tdeee0" data-mpi={idx}>
                {step}
              </span>)}
            <span className="px-4 py-2 text-slate-600" data-id="element-909" data-mp="162xi43dtd572">→</span>
            {['Interview', 'Commit', 'Onboard', 'Integrate', 'Train', 'Launch', 'Retain'].map((step, idx) => <span key={idx} className="px-4 py-2 bg-slate-900 border border-slate-800 rounded-full text-slate-500" data-id="element-910" data-mp="11zhnfclb1ex0" data-mpi={idx}>
                {step}
              </span>)}
          </div>
          <p className="text-xs text-slate-500 mt-6" data-id="element-911" data-mp="s3o4nbgzsp6s">
            Infrastructure stages (highlighted) vs. execution stages
          </p>
        </div>
      </section>

      {/* 5. LMS + SUPPORT */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-912" data-mp="ictc5pd5ktcw">
        <div className="flex items-start space-x-6 bg-slate-900/30 border border-slate-800 rounded-xl p-8" data-id="element-913" data-mp="4c8wh22jbdnm">
          <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-914" data-mp="9ak6bcstxo5u">
            <BookOpen className="w-6 h-6 text-slate-400" data-id="element-915" data-mp="osbs3mlobixm" />
          </div>
          <div data-id="element-916" data-mp="jua72w4ot9ji">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-917" data-mp="jvl84o6r036x">
              Learning Management System Access
            </h3>
            <p className="text-slate-300 mb-4 leading-relaxed" data-id="element-918" data-mp="fr3uz7uw8o54">
              All Edge partners receive access to HIRE's Learning Management
              System covering recruiting and hiring best practices.
            </p>
            <ul className="space-y-2 text-slate-400 text-sm" data-id="element-919" data-mp="140woyyqybgq">
              <li className="flex items-start" data-id="element-920" data-mp="12haysubn87k">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-921" data-mp="3sa27d6esv31u" />
                DIY reference library
              </li>
              <li className="flex items-start" data-id="element-922" data-mp="3oabcorm5k2s1">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-923" data-mp="3j9dw2jgsjgsn" />
                Optional support and guidance
              </li>
              <li className="flex items-start" data-id="element-924" data-mp="3eb2mm9uer8ay">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-925" data-mp="1tss2of139e87" />
                Not a replacement for internal execution
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 7. WHO EDGE IS FOR */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-926" data-mp="23r7ivmykv32x">
        <div className="max-w-5xl mx-auto" data-id="element-927" data-mp="27qzsm2zpjf9v">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-928" data-mp="1b20nuxyc0vmf">
            Who Edge Is For
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-929" data-mp="1g0logyhhxhbe">
            <div data-id="element-930" data-mp="1fyqz97z6z31i">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-931" data-mp="1k2yqpcx1ax3f">
                <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-932" data-mp="1k0vuuc97a9qs" />
                Edge is a good fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-933" data-mp="sc2fshujb2is">
                {['Already have strong onboarding and training', 'Want better candidate quality and predictability', 'Prefer to keep hiring decisions internal', 'Want a lower-commitment entry point'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-934" data-mp="4fx0xse1hp22" data-mpi={idx}>
                    <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-935" data-mp="8fxelatbdw82" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-936" data-mp="3cux5mruk1ku4">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-937" data-mp="3cvgqagblanbu">
                <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-938" data-mp="3gw0j57p4r4s6" />
                Edge is not a good fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-939" data-mp="3ls7k0m2o5q39">
                {['Want help fixing retention', 'Want hiring standards designed for you', 'Want recruiting execution handled externally'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-940" data-mp="2y352de81bx8r" data-mpi={idx}>
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-941" data-mp="2qk5kjd082dri" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. UPGRADE PATH */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-942" data-mp="2clfn1w9hqc2m">
        <div className="flex items-start space-x-6 bg-slate-900/30 border border-slate-800 rounded-xl p-8" data-id="element-943" data-mp="2cl5xuaw9s8xz">
          <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-944" data-mp="27ofixqw7bje5">
            <TrendingUp className="w-6 h-6 text-slate-400" data-id="element-945" data-mp="22tt2387coymo" />
          </div>
          <div data-id="element-946" data-mp="1xwsyd3xz47yq">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-947" data-mp="1xu6qt4b31sgi">
              Natural Progression
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-948" data-mp="1ovv1r6pv72q6">
              Many Edge partners later move into Advantage when they want system
              ownership and accountability — without changing platforms or
              starting over.
            </p>
          </div>
        </div>
      </section>

      {/* 9. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-949" data-mp="1eazsej86mb5p">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-950" data-mp="10bhxdm4am1nw">
          See if HIRE Edge fits your hiring model.
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-slate-700 hover:bg-slate-600 text-white font-bold rounded-lg transition-all" data-id="element-951" data-mp="15auncfqgnoup">
          Learn More
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-952" data-mp="1xz8h2jainz0g" />
        </button>
      </section>
    </div>;
}